import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../rootReducer';
import { useNavigate, useParams } from '../../../navigation';
import { logEvent, getAnalytics } from 'firebase/analytics';
import TrackingContext from '../../Providers/TrackingContext';
import store from '../../../store';
import { TTOrderCreate } from '../../../interfaces/order';
import { getModifierPairingTotal, getPrice } from './DishCard';
import { CheckoutContext } from '../../Providers/CheckoutContext';

type Props = {
  cta?: string;
};

const CartBanner: React.FC<Props> = ({ cta = 'View Cart' }) => {
  const cart = useSelector<RootState, boolean>(state => {
    return state.cart.cart_items.length != 0;
  });
  const order_create = useSelector<RootState, TTOrderCreate>(state => {
    return state.cart.order_create;
  });
  const currentCheckout = useContext(CheckoutContext);
  const analytics = getAnalytics();
  const { trackPageView, trackFBEvent, trackGAEvent } = useContext(
    TrackingContext,
  );
  const navigate = useNavigate();
  // @ts-ignore
  const { r_id } = useParams();

  return (
    <>
      {cart && (
        <div
          className="w-full fixed bottom-0 md:-mx-8 lg:-mx-16 xl:-mx-32 group hover:cursor-pointer z-20"
          onClick={() => {
            logEvent(analytics, 'view_cart_clicked');
            logEvent(analytics, 'view_cart', {
              merchant_id: r_id,
            });
            trackFBEvent(
              'InitiateCheckout',
              {
                value:
                  order_create?.order_items
                    ?.map(i => {
                      return getPrice(i, getModifierPairingTotal(i)) / 100.0;
                    })
                    ?.reduce((a, b) => a + b, 0) / 100.0,
                num_items: order_create?.order_items?.length ?? 0,
                currency: 'USD',
                contents: order_create?.order_items?.map(i => {
                  return {
                    quantity: i.quantity,
                    id: `prod_${i.menu_item_id}`,
                    name: i.name,
                    price: getPrice(i, getModifierPairingTotal(i)) / 100.0,
                  };
                }),
              },
              false,
              store.getState().cart.order_create?.restaurant_ids,
            );
            trackGAEvent(
              'view_cart',
              {
                currency: 'USD',
                value:
                  order_create?.order_items
                    ?.map(i => {
                      return getPrice(i, getModifierPairingTotal(i)) / 100.0;
                    })
                    ?.reduce((a, b) => a + b, 0) / 100.0,
                items: order_create?.order_items?.map(i => {
                  return {
                    quantity: i.quantity,
                    item_id: `prod_${i.menu_item_id}`,
                    item_name: `${i.name}`,
                    affiliation: 'SNAPnTAP',
                    price: getPrice(i, getModifierPairingTotal(i)) / 100.0,
                  };
                }),
              },
              store.getState().cart.order_create?.restaurant_ids,
            );
            navigate(`/feed/restaurants/${r_id}/plate`);
          }}
        >
          <div className="flex flex-row bg-primary md:rounded-t-md  p-4 md:mx-8 lg:mx-16 xl:mx-32 items-center justify-center shadow-sm">
            <div className="flex flex-col justify-center leading-normal">
              <div className="flex items-center">
                <div className="text-on-primary font-bold text-lg text-center mx-auto">
                  {currentCheckout?.checkout_continue_btn_title ?? cta}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CartBanner;
